import api from '../../api'

export type TenantReportData = {
  totalTenants: number
  soldJobs: number
  totalFinalPrice: number
  totalSoldJobsTenants: number
  totalProposalsCreated: number
  totalProposalsApproved: number
  totalProposalsSent: number
  totalProposalFollowUps: number
  totalProposalPortalViews: number
  currentYearSentProposals: number
  currentYearApprovedProposals: number
  currentYearSentFollowUpProposals: number
  currentYearSentApprovedFollowUpProposals: number
  currentYearSentNonFollowUpProposals: number
  currentYearSentNonApprovedFollowUpProposals: number
  followUpApprovedOnStepData: FollowUpApprovedOnStepData[]
  daysToCloseData: DaysToClose
  dayItClosedData: DayItClosedData[]
  proposalTurnaroundData: ProposalTurnaroundData
}

export type DaysToClose = {
  totalDaysToClose: number
  proposalTotal: number
}

export type DayItClosedData = {
  daysToClose: number
  total: number
}

export type ProposalTurnaroundData = {
  totalProposalTurnaroundDays: number
  proposalTotal: number
}

export type FollowUpApprovedOnStepData = {
  approvedStep: number
  total: number
}

export const getTenantReport = async (startDate: string, endDate: string) => {
  const response = await api.get<TenantReportData>(`/web/tenant-report/${startDate}/${endDate}`)
  return response.data
}

export type ApprovedStepWithTotalPrice = {
  approvedStep: number
  total: number
  dollarAmount: number
}

export type ProposalsReportData = {
  totalProposalsApproved: number
  totalProposalsSent: number
  totalProposalFollowUpsSent: number
  totalPriceSent: number
  totalPriceApproved: number
  totalPriceFollowUp: number
  approvedStepWithTotalPrice: ApprovedStepWithTotalPrice[]
}

export const getProposalsReport = async (startDate: string, endDate: string) => {
  const response = await api.get<ProposalsReportData>(`/web/tenant-report/proposals/${startDate}/${endDate}`)
  return response.data
}